import React from 'react';
import { X, Check } from 'lucide-react';
export function BeliefChange() {
  return <section className="w-full bg-cream py-20 md:py-28 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-center" data-id="element-2">
        {/* Text Content */}
        <div className="space-y-8" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold text-dark" data-id="element-4">
            El problema no es tu hijo. <br data-id="element-5" />
            <span className="text-terracotta" data-id="element-6">Es el orden.</span>
          </h2>

          <div className="space-y-6" data-id="element-7">
            {['Memorizar sin entender genera bloqueo.', 'La lectura no empieza en palabras. Empieza en sonidos.', 'Cuando activás la base correcta, la confianza aparece.'].map((text, index) => <div key={index} className="flex items-start space-x-4" data-id="element-8">
                <span className="flex-shrink-0 w-8 h-8 rounded-full bg-gold/20 text-olive-dark font-serif font-bold flex items-center justify-center text-lg border border-gold/30" data-id="element-9">
                  {index + 1}
                </span>
                <p className="text-lg text-dark/80 pt-1" data-id="element-10">{text}</p>
              </div>)}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4" data-id="element-11">
            <div className="bg-red-50 p-4 rounded-xl border border-red-100 flex items-center space-x-3" data-id="element-12">
              <X className="w-5 h-5 text-red-400 shrink-0" data-id="element-13" />
              <span className="text-sm font-medium text-red-800" data-id="element-14">
                Sin activación → frustración
              </span>
            </div>
            <div className="bg-green-50 p-4 rounded-xl border border-green-100 flex items-center space-x-3" data-id="element-15">
              <Check className="w-5 h-5 text-green-600 shrink-0" data-id="element-16" />
              <span className="text-sm font-medium text-green-800" data-id="element-17">
                Con activación → comprensión + orgullo
              </span>
            </div>
          </div>
        </div>

        {/* Image Content */}
        <div className="relative" data-id="element-18">
          <div className="absolute -inset-4 bg-gold/10 rounded-full blur-3xl opacity-40 -z-10" data-id="element-19"></div>
          <img src="https://cdn.magicpatterns.com/uploads/1wKAvzHN4oMGuLpCZGTxyH/alegria.jpg" alt="Madre e hijo leyendo felices" className="w-full h-auto rounded-2xl shadow-xl object-cover" data-id="element-20" />
        </div>
      </div>
    </section>;
}